import { render, staticRenderFns } from "./TaskDetail.vue?vue&type=template&id=029ecf01&scoped=true&"
import script from "./TaskDetail.vue?vue&type=script&lang=js&"
export * from "./TaskDetail.vue?vue&type=script&lang=js&"
import style0 from "./TaskDetail.vue?vue&type=style&index=0&id=029ecf01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029ecf01",
  null
  
)

export default component.exports